class RequestSink {
  private isOpen = false;
  open() {
    this.isOpen = true;
  }
  // oxlint-disable-next-line typescript/no-explicit-any
  pipe(onFulfilled: () => Promise<any>) {
    if (this.isOpen) {
      return new Promise<never>(() => {
        /** intercept all requests and do nothing, so that the request never goes through */
      });
    }
    return onFulfilled();
  }
}

export const requestSink = new RequestSink();

/** Opens the request sink, intercepting all requests and preventing them from going through. */
export const openRequestSink = requestSink.open.bind(requestSink);
